module.exports = __webpack_public_path__ + "img/logo-en-botton-blue.50fe959.svg";